<template>
  <div class="content">
    <div class="p">
      <b>If CT extended</b> check the connection at the point of extension.
    </div>

    <div class="p">
      Note that when extending CTs Allume recommend:
      <ul class="p">
        <li>Shielded, twisted pair cable of 0.25mm2 (24AWG) or larger</li>
        <li><b>Shielding is grounded</b></li>
      </ul>
    </div>

    <div class="p" data-tn="ct-error-list">
      Connection to check:
      <ul class="p">
        <li v-for="(unit, i) in CTNotReadingUnits" :key="i">{{ unit }}</li>
      </ul>
    </div>

    <back-and-next
      next-text="Next - At Solshare"
      to="/commission/error/ct-not-reading-uk/5"
      data-tn="ct-not-reading-uk/4"
    >
    </back-and-next>
  </div>
</template>

<script>
import { CommissionErrorMixin } from "../../../../../mixins/commissionError";

export default {
  mixins: [CommissionErrorMixin],
};
</script>

<style scoped lang="less">
.content {
  .p {
    margin-top: 20px;
  }
}
</style>
